import { Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HorizontalScroll from "../../../../components/CategoryButtons/categoryButtons";
import CustomDrawerFooter from "../../../../components/CustomDrawar/customDrawarFooter";
import CustomDrawerHeader from "../../../../components/CustomDrawar/customDrawarHeader";
import SnackbarAlert from "../../../../components/SnackBar";
import { setTabActive } from "../../../../lib/slices/tabActiveSlice";
import { getAllServices } from "../../../../services/Services";
import { featchAllTeam } from "../../../../services/Team";
import AppointmentCard from "../Cards";

const ServicesStep = ({
  handleCreateTeamData,
  setIsLoading,
  selectedServices,
}) => {
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate();
  const tabActive = useSelector((state) => state.tabActive.tabs);
  const dispatch = useDispatch();
  const [renderServices, setRenderServices] = useState([]);
  const [allTeams, setAllTeams] = useState([]);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    handleFetchAllServices();
  }, []);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleFetchAllServices = async () => {
    try {
      setIsLoading(true);
      const response = await getAllServices(selectedBranch);
      setIsLoading(false);
      if (response?.status === 200 || response.status === 201) {
        const fetchedData = response?.data?.data;

        const updatedData = fetchedData.map((item) => ({
          ...item,
          services: item?.services?.map((service) => ({
            ...service,
            isSelected: selectedServices?.some(
              (selected) => selected._id === service._id
            ),
          })),
        }));

        setActiveTab({ ...updatedData[0], index: 0 });
        setRenderServices(updatedData);
      } else {
        console.log("Error fetching services");
      }
    } catch (error) {
      setIsLoading(false);
      console.log("Error:", error);
    }
  };

  const handleAddService = (tabIndex, serviceIndex) => {
    const updatedServices = [...renderServices];
    updatedServices[tabIndex].services[serviceIndex].isSelected = true;
    setRenderServices(updatedServices);
  };

  const handleRemoveService = (tabIndex, serviceIndex) => {
    const updatedServices = [...renderServices];
    updatedServices[tabIndex].services[serviceIndex].isSelected = false;
    setRenderServices(updatedServices);
  };

  const handleContinue = async () => {
    const selectedIds = renderServices
      .flatMap((item) =>
        item?.services
          ?.filter((service) => service?.isSelected)
          .map((service) => service?._id)
      )
      .filter((id) => id);

    const selectedServices = renderServices.flatMap((item) =>
      item?.services?.filter((service) => service?.isSelected)
    );
    if (selectedIds?.length > 0) {
      const allTeamMembers = await handleFetchAllTeams(selectedIds);
      let data = {
        selectedServices,
        selectedIds,
        allTeams: allTeamMembers,
      };
      handleCreateTeamData(data);
      dispatch(setTabActive(1));
    } else {
      handleSnackbarVal(true, "error", "Please select a service first");
    }
  };

  const handleFetchAllTeams = async (selectedIds) => {
    const payload = {
      branchID: selectedBranch,
      selectedServiceIds: selectedIds,
    };
    try {
      setIsLoading(true);
      const response = await featchAllTeam(payload);
      setIsLoading(false);
      if (response?.status === 200 || response?.status === 201) {
        const data = response?.data?.teamMembers || [];
        setAllTeams(data);
        return data;
      } else {
        dispatch(setTabActive(2));
        return [];
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchAllTeams ~ error:", error);
      return [];
    }
  };

  return (
    <>
      <Stack
        height={"100%"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
      >
        <Stack>
          <CustomDrawerHeader title={"Select Services"} />
          <HorizontalScroll
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            renderServices={renderServices}
          />
          <Box>
            {activeTab?.services?.map((service, index) => (
              <AppointmentCard
                key={index}
                service={service}
                handleAddService={() =>
                  handleAddService(activeTab?.index, index)
                }
                handleRemoveService={() =>
                  handleRemoveService(activeTab?.index, index)
                }
              />
            ))}
          </Box>
        </Stack>
        <CustomDrawerFooter
          activeStep={tabActive}
          btnTitle={"Book Now"}
          onNext={handleContinue}
        />
      </Stack>
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </>
  );
};

export default ServicesStep;

let data = {
  branchID: "67d1d749f15a204ceab8286c",
  selectedServiceIds: ["67d1f14ff15a204ceab82a58"],
};
const dataasdas = {
  branchID: "67d1dfd1f15a204ceab828dc",
  selectedServiceIds: ["67d1f14ff15a204ceab82a58"],
};
